
interface IPageWithFootnotesProps {
    children: React.ReactNode;
    footnotes: Array<{ id: string; text: string }>;
}

const PageWithFootnotes = (props: IPageWithFootnotesProps) => {
    const {children, footnotes = []} = props;

    return (
        <div className="page">
            <div>
                {children}
            </div>
            <div className="footnotes">
                {footnotes.map(fn => {
                    const {id, text} = fn;
                    return (
                        <p key={id}><sup>{id}</sup> {text}</p>
                    );
                })}
            </div>
        </div>
    );
};

export default PageWithFootnotes;
